import { CardContent, Grid, Paper, Typography, Box } from '@material-ui/core';
import React from 'react';
import { CheckBoxFastField, TextFieldFastField } from '../../../components';

interface SampleDevelopmentHlDesignProps {
  isCrtLocked?: boolean;
}

const SampleDevelopmentHlDesign: React.FC<SampleDevelopmentHlDesignProps> = (props) => {
  const { isCrtLocked = false } = props;

  return (
    <Box m={1}>
      <Paper variant="outlined">
        <CardContent>
          <Grid
            container
            spacing={1}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            item
            xs={12}
          >
            <Grid item xs={3}>
              <Typography>Design</Typography>
            </Grid>
            <Grid
              container
              spacing={1}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              item
              xs={12}
            >
              <Grid item xs={12} md={2}>
                <Typography>Design:</Typography>
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="ownDesign"
                  label="Own Design"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="customerDesign"
                  label="Customer Design"
                />
              </Grid>
              <Grid item xs={12} md={5} />
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="designSample"
                  label="Sample"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="designOriginal"
                  label="Original"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="designArtwork"
                  label="Artwork"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField disabled={isCrtLocked} name="designZip" label="Zip" />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField disabled={isCrtLocked} name="designCD" label="CD" />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="designFilm"
                  label="Film"
                />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="designMail"
                  label="Mail"
                />
              </Grid>
              <Grid item xs={12} md={8} />
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="designFile"
                  label="File"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField disabled={isCrtLocked} name="designTIF" label="TIF" />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField disabled={isCrtLocked} name="designEPS" label="EPS" />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField disabled={isCrtLocked} name="designJPG" label="JPG" />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField disabled={isCrtLocked} name="designPDF" label="PDF" />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField disabled={isCrtLocked} name="designAI" label="AI" />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={2}>
                <CheckBoxFastField disabled={isCrtLocked} name="designQXP" label="QXP" />
              </Grid>
              <Grid item xs={12} md={8} />
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="designSoftware"
                  label="Software"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="designAcrobat"
                  label="Acrobat"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextFieldFastField
                  disabled={isCrtLocked}
                  name="designAcrobatData"
                  label="Acrobat"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4} />
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="designIllustrater"
                  label="Illustrater"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextFieldFastField
                  disabled={isCrtLocked}
                  name="designIllustraterData"
                  label="Illustrater"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4} />
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="designPageMaker"
                  label="PageMaker"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextFieldFastField
                  disabled={isCrtLocked}
                  name="designPageMakerData"
                  label="PageMaker"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4} />
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="designPhotoshop"
                  label="Photoshop"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextFieldFastField
                  disabled={isCrtLocked}
                  name="designPhotoshopData"
                  label="Photoshop"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4} />
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="designFreeHand"
                  label="Free Hand"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextFieldFastField
                  disabled={isCrtLocked}
                  name="designFreeHandData"
                  label="Free Hand"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4} />
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="designQuark"
                  label="Quark"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextFieldFastField
                  disabled={isCrtLocked}
                  name="designQuarkData"
                  label="Quark"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4} />
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="designOther"
                  label="Other"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextFieldFastField
                  disabled={isCrtLocked}
                  name="designOtherData"
                  label="Other"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Paper>
    </Box>
  );
};

export default SampleDevelopmentHlDesign;
